import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { GetAnfrageByIdResolver } from "../resolver/anfrage/get-anfrage-by-id.resolver";
import { PaymentComponent } from "../features/funds/forms/payment/payment.component";
import { GetAllAnfrageFundingAmountsResolver } from "../resolver/funds/get-all-anfrage-funding-amounts.resolver";
import { FundingAmountComponent } from "../features/funds/forms/funding-amount/funding-amount.component";
import { FundingAmountGuard } from "../guards/funds/funding-amount.guard";
import { PaymentGuard } from "../guards/funds/payment.guard";
import { FundingDetailComponent } from "../features/funds/forms/funding-detail/funding-detail.component";
import { InformationenProcessStepComponent } from "../features/anfrage/forms/informationen-process-step/informationen-process-step.component";

export class FundsRoutingFactory extends BaseRoutingFactory {
    private readonly coreFundsRoute: Routes = [
        {
            path: ':scope/:id',
            component: this.componentService.get(FundingDetailComponent),
            data: { useAnfrageLanguage: true },
            resolve: {
                anfrage: this.componentService.get(GetAnfrageByIdResolver),
            },
            title: () => this.translateService.instant("payments") + " | " + this.translateService.instant("xfound.portal.tabname"),
            children: [
                {
                    path: 'payment',
                    component: this.componentService.get(PaymentComponent),
                    resolve: {
                        fundingAmounts: this.componentService.get(GetAllAnfrageFundingAmountsResolver),
                    },
                    canActivate: [this.componentService.get(PaymentGuard)],
                },
                {
                    path: 'funding-amount',
                    component: this.componentService.get(FundingAmountComponent),
                    resolve: {
                        fundingAmounts: this.componentService.get(GetAllAnfrageFundingAmountsResolver),
                    },
                    canActivate: [this.componentService.get(FundingAmountGuard)],
                },
                {
                    path: 'information/:abschnittid',
                    component: this.componentService.get(InformationenProcessStepComponent),
                },
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }
    
    protected get coreRoute(): Routes {
        return this.coreFundsRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
    
}